module.exports = __webpack_public_path__ + "img/contentBox1_info_img2.a9ac0d69.png";